// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7bd081c8] .van-nav-bar{height:13.333vw}[data-v-7bd081c8] .van-nav-bar .van-nav-bar__content{line-height:13.333vw;height:13.333vw;background:#fff}[data-v-7bd081c8] .van-nav-bar .van-nav-bar__content .van-nav-bar__title{font-size:4.8vw;color:#242424}[data-v-7bd081c8] .van-nav-bar .van-nav-bar__content .van-icon{font-size:5.333vw;color:#242424}[data-v-7bd081c8] h1{font-size:5.333vw!important}[data-v-7bd081c8] h2{font-size:4vw!important}", ""]);
// Exports
module.exports = exports;
